import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { DetailPane } from "@/components/layout/detail-panel"
import useCustomToast from "@/hooks/use-custom-toast"
import { requirePermission } from "@/lib/require-permission"
import { ProgrammeCreateForm } from "./-components/form/programme-form"

export const Route = createFileRoute("/_layout/maintenance-programmes/new")({
  staticData: { breadcrumb: "New", detailSidebar: true },
  beforeLoad: ({ context: { queryClient } }) =>
    requirePermission(queryClient, "maintenance_programme:create", "/"),
  component: NewProgrammePane,
})

function NewProgrammePane(): React.ReactElement {
  const navigate = useNavigate({ from: Route.fullPath })
  const showToast = useCustomToast()
  const close = () => navigate({ to: "/maintenance-programmes", search: true })

  return (
    <DetailPane title="New program" onClose={close}>
      <ProgrammeCreateForm
        onCreate={(created) => {
          showToast(`Created ${created.number}`, created.title, "success")
          navigate({
            to: "/maintenance-programmes",
            search: (previous) => ({
              ...previous,
              tab: created.status === "active" ? previous.tab : undefined,
            }),
          })
        }}
        onCancel={close}
      />
    </DetailPane>
  )
}
